import {observable} from "mobx";

const WS = observable({
  dev: location.hostname === "localhost",
  local: location.hostname === "localhost",
  width: window.innerWidth,
  height: window.innerHeight,
  xs: window.innerWidth < 640,
  md: window.innerWidth >= 640 && window.innerWidth <= 900,
  full: window.innerWidth > 900
})

function handleResize() {
  // Set window width/height to state
  WS.width = window.innerWidth;
  WS.height = window.innerHeight;
  WS.xs = window.innerWidth < 640;
  WS.md = window.innerWidth >= 640 && window.innerWidth <= 900;
  WS.full = window.innerWidth > 900;
}

window.addEventListener("resize", handleResize);

export default WS;
